const { documentElement } = document;
const { body } = document;
const pageYOffsetSupport = typeof window.pageYOffset !== 'undefined';

/**
 * Return the X and Y scroll position
 * @return {number[]}
 */
export function getScroll() {
  if (pageYOffsetSupport) {
    return [window.pageXOffset, window.pageYOffset];
  }

  const sx = documentElement.scrollLeft || body.scrollLeft || 0;
  const sy = documentElement.scrollTop || body.scrollTop || 0;
  return [sx, sy];
}

/**
 * Return Y scroll position
 * @return number
 */
export function getScrollY() {
  if (pageYOffsetSupport) {
    return window.pageYOffset;
  }

  return documentElement.scrollTop || body.scrollTop || 0;
}
